import React, { InputHTMLAttributes } from 'react';
import styled from 'styled-components';

const Switch: React.FC<InputHTMLAttributes<HTMLInputElement>> = props => {
  return (
    <SwitchLabel>
      <input type="checkbox" {...props} />
      <SwitchSlider />
    </SwitchLabel>
  );
};

const SwitchSlider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${({ theme }) => theme.colors.highlight};
  border-radius: 20px;
  transition: 0.4s;

  ::before {
    position: absolute;
    content: '';
    height: 26px;
    width: 26px;
    left: 4px;
    bottom: 4px;
    background-color: ${({ theme }) => theme.colors.muted};
    border-radius: 20px;
    transition: 0.4s;
  }
`;

const SwitchLabel = styled.label`
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;

  input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  input:checked + ${SwitchSlider} {
    background-color: ${({ theme }) => theme.colors.highlight};
  }

  input:checked + ${SwitchSlider}::before {
    background-color: ${({ theme }) => theme.colors.primary};
  }

  input:disabled + ${SwitchSlider}::before {
    background-color: ${({ theme }) => theme.colors.muted};
  }

  input:focus + ${SwitchSlider} {
    box-shadow: 0 0 1px #2196f3;
  }

  input:checked + ${SwitchSlider}:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
  }
`;

export default Switch;
